import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsDashboardsRoute: InvariantJiraRoute = {
	name: 'assets-dashboards',
	path: '/jira/assets/dashboards',
	exact: true,
};
